import styled from 'styled-components';
import { palette } from 'styled-tools';

import { Button, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

export const Wrapper = styled.section`
	background: linear-gradient(180deg, ${palette('white')} 0%, #eff0ff 100%);
	padding: 120px 0 60px;
`;

export const Grid = styled.div`
	margin: 0 auto;
	max-width: calc(100% - 40px);

	${minWidth('desktop')} {
		align-items: center;
		display: grid;
		grid-gap: 40px;
		grid-template-columns: 2fr 2fr;
		max-width: 960px;
	}
`;

export const Content = styled.div`
	margin: 0 auto 74px;
	text-align: center;
	max-width: 650px;
	text-align: center;

	${minWidth('desktop')} {
		margin: 0;
		max-width: none;
		text-align: left;
	}
`;

export const RatingsTitle = styled.div`
	font-size: 36px;
	${fontWeight(FontWeights.Light)};
	margin-bottom: 24px;
`;

export const TileSubtitle = styled.div`
	align-items: center;
	color: ${palette('gray7')};
	font-size: 18px;
	${fontWeight(FontWeights.Light)};
	flex-wrap: wrap;
	display: flex;
	justify-content: center;

	${minWidth('desktop')} {
		justify-content: flex-start;
	}
`;

export const Star = styled.img`
	height: 24px;
	margin-right: 20px;
`;

export const Testimonial = styled.div`
	border-radius: 10px;
	background: ${palette('white')};
	color: ${palette('gray7')};
	font-size: 16px;
	${fontWeight(FontWeights.Regular)};
	line-height: 1.5;
	margin: 0 auto;
	max-width: 450px;
	padding: 46px 40px;
	text-align: center;

	${minWidth('desktop')} {
		margin: 0;
		max-width: none;
	}
`;

export const FreeButton = styled(Button)`
	margin: 66px auto 0;
	width: 255px;
`;

export const FooterText = styled.div`
	color: ${palette('gray7')};
	${fontWeight(FontWeights.Regular)};
	font-size: 13px;
	letter-spacing: 0.5px;
	line-height: 16px;
	grid-column: 1 / 3;
	margin-top: 120px;
	text-align: center;
`;

export const ButtonWrapper = styled.div`
	grid-column: 1 / 3;
	display: flex;
	width: 100%;
	justify-content: center;
`;
